import { forwardRef } from "react";
import cx from "classnames";
import GptAd, { GptAdProps } from "./GptAd";
import styles from "./ArticleInjector.module.scss";

/**
 * An injector ad that runs within the Swan article layout at full width.
 */
const ArticleInjector = forwardRef<HTMLElement, GptAdProps>(
  function ArticleInjector({ className, targetingPos, ...props }, ref) {
    return (
      <GptAd
        ref={ref}
        className={cx(
          styles.root,
          className,
          "s-native s-native--standard s-native--streamline"
        )}
        format="injector"
        sizesAt0="mobile-wide,native"
        sizesAt976="desktop-wide,native,house"
        targetingPos={targetingPos || "csi-ad"}
        {...props}
      />
    );
  }
);

export default ArticleInjector;
